<template>
  <span ref="comment">
    <li
      :class="[
        { 'other-author': !comment.author_is_user },
        { author_is_current: comment.author_is_user },
        { 'is-editing': editing },
      ]"
    >
      <div class="comment-user">
        <span v-if="comment.user" class="name">
          {{ replace(comment.user.name, "| Keepers") }}
        </span>
        <span class="name" v-else> No name registered </span>
        <span class="date"> · {{ comment.last_edited_at }} </span>
      </div>
      <textarea
        ref="commentBody"
        v-show="comment.author_is_user"
        :readonly="!editing"
        v-model="comment.body"
      >
      </textarea>
      <span v-show="!comment.author_is_user">
        {{ comment.body }}
      </span>
    </li>
    <div v-if="!editing" class="flex actions">
      <div class="edit-button" @click="startEditingComment">Rediger</div>
      <div class="edit-button text-danger" @click="deleteComment">Slet</div>
    </div>
    <div v-else class="flex actions">
      <div class="edit-button" @click="updateComment">Gem</div>
      <div class="edit-button" @click="editing = false">Annuller</div>
    </div>
  </span>
</template>

<script>
import axios from "axios";
export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
    };
  },
  mounted() {
      this.$refs.commentBody.style.height = (this.$refs.commentBody.scrollHeight > this.$refs.commentBody.clientHeight) ? (this.$refs.commentBody.scrollHeight)+"px" : "60px";
  },
  methods: {
    replace(string, replace) {
      return string.replaceAll(replace, "");
    },
    startEditingComment() {
      this.editing = true;
      this.$refs.commentBody.focus();
    },
    deleteComment() {
      axios
        .delete(`/dashboard/admin/comments/${this.comment.id}`)
        .then((response) => {
          this.$refs.comment.remove();
          this.$emit("changed");
        });
    },
    updateComment() {
      if (this.comment.body === "") {
        return this.deleteComment();
      }

      axios
        .patch(`/dashboard/admin/comments/${this.comment.id}`, {
          body: this.comment.body,
        })
        .then((response) => {
          this.$emit("changed");
          this.editing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.other-author,
.author_is_current {
  text-align: left;
}

.comment-user {
  .name {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .date {
    font-size: 80%;
    opacity: 0.6;
  }
}

.flex {
  display: flex;
  justify-content: flex-end;
}

.edit-button {
  margin-top: 10px;
  margin-right: 6px;
  font-size: 81%;
  text-decoration: underline;
  text-align: right;
  cursor: pointer;
}

.author_is_current textarea {
  width: 100%;
  display: block;
  resize: none;

  &:focus {
    outline: none;
  }

  &[readonly="readonly"] {
    pointer-events: none;
  }
}

.other-author + .flex .edit-button {
  display: none;
}

.actions {
  margin-bottom: 15px;
}
</style>